module.exports = require("lazy-get-decorator");